import { IOcojoRegistry, IOcojoRepository } from "../../../domain/ocojo";
import { OcojoRepository } from ".";

export class OcojoRegistry implements IOcojoRegistry {
  constructor(getToken: () => string) {
    this._repository = new OcojoRepository(getToken);
  }

  private readonly _repository: IOcojoRepository;

  getOcojoRepository(): IOcojoRepository {
    return this._repository;
  }
}
